module.exports = __webpack_public_path__ + "img/cert_05.8b88f7d0.jpg";